import { TZDate } from '@date-fns/tz';

import type { EligiblePromotion } from '@libs/common-types';
import { isDateInRange } from '@libs/core';

type filterPromotionsProps = {
    promotions: EligiblePromotion[];
    isAutoshipHeader?: boolean;
};

export const filterActiveAlgoliaPromotions = ({ promotions, isAutoshipHeader }: filterPromotionsProps) => {
    const currentDate = new TZDate(new Date(), 'America/Phoenix');

    // Filter out of date promotions, and those missing promoText
    // or if AutoshipHeader, filter out promotions without a discountDisplay
    return promotions.filter(
        ({ promoStart, promoEnd, promoText, discountDisplay }) =>
            isDateInRange(currentDate, [promoStart, promoEnd]) &&
            ((!isAutoshipHeader && !!promoText) || (isAutoshipHeader && !!discountDisplay))
    );
};
